import * as React from 'react';
import { SvgComponentProps, Svg } from './svg-component';

export const TypeCCSIcon = ({ size, ...rest }: SvgComponentProps) => (
    <Svg width={size || 48} height={size || 48} viewBox="0 0 24 24" fill="none" {...rest}>
        <g clipPath="url(#clip0_8_10877)">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="m7.41 15.898-.002-.002a10.1 10.1 0 0 1-3.458-3.184C.394 7.425 3.215 2.97 3.601 2.442 4.826 0 8.866 0 9.021 0h5.941l.036-.001c.424-.018 4.204-.175 5.414 2.436.409.594 3.178 5.027-.356 10.27a10.1 10.1 0 0 1-3.486 3.193h.62a4.047 4.047 0 0 1 0 8.093H6.794a4.047 4.047 0 1 1 0-8.093h.616ZM14.424 5.61a1.355 1.355 0 1 1 0-2.71 1.355 1.355 0 0 1 0 2.71Zm-4.925 0a1.355 1.355 0 1 1-.013-2.71A1.355 1.355 0 0 1 9.5 5.61ZM5.656 9.644a2.03 2.03 0 0 0 1.127.342 2.035 2.035 0 0 0 2.03-2.03 2.029 2.029 0 1 0-3.157 1.688Zm6.059.342a2.029 2.029 0 1 1 2.028-2.03 2.035 2.035 0 0 1-2.029 2.03Zm3.804-.342a2.03 2.03 0 0 0 1.127.342 2.035 2.035 0 0 0 2.029-2.03 2.028 2.028 0 1 0-3.156 1.688Zm-6.27 4.78a2.028 2.028 0 1 1 0-4.056 2.028 2.028 0 0 1 0 4.056Zm3.804-.342a2.028 2.028 0 1 0 2.254-3.372 2.028 2.028 0 0 0-2.254 3.372Zm1.792 7.551a2.094 2.094 0 1 0 2.327-3.481 2.094 2.094 0 0 0-2.327 3.481Zm-6.803.353a2.094 2.094 0 1 1-.015-4.187 2.094 2.094 0 0 1 .015 4.187Z"
                fill="currentColor"
            />
        </g>
        <defs>
            <clipPath id="clip0_8_10877">
                <rect width="24" height="24" fill="white" />
            </clipPath>
        </defs>
    </Svg>
);
